import ArchivedIcon from './ArchivedIcon';
import CompactComponent from './Compact';
import DraftIcon from './DraftIcon';
import EndedIcon from './EndedIcon';
import Label from './Label';
import LiveIcon from './LiveIcon';
import Root from './Root';
import TransitionIcon from './TransitionIcon';

export { DraftIcon as StateIconDraft };

export const StateIcon = Object.assign(CompactComponent, {
  Root,
  Label,
  DraftIcon,
  LiveIcon,
  EndedIcon,
  ArchivedIcon,
  TransitionIcon,
});

export type { CompactComponentProps as StateIconProps } from './Compact';
